import { Anchor } from "@aircall/ds";
import { Trans, useTranslation } from "react-i18next";

import { TranscriptionIllustrationLayout } from "../../../TranscriptionIllustrationLayout";
import { TranscriptionMessageTitle } from "../../../TranscriptionMessageTitle";
import { TranscriptionSubTitle } from "../../../TranscriptionSubTitle";

import TranscriptionWrongCallDurationSvg from "@/assets/transcription_wrong_call_duration.svg?react";

export function TranscriptionWrongCallDuration() {
  const { t } = useTranslation();

  return (
    <TranscriptionIllustrationLayout data-test="transcription-not-enabled-message">
      <TranscriptionWrongCallDurationSvg />
      <TranscriptionMessageTitle>
        {t("no_transcript.wrong_call_duration_title")}
      </TranscriptionMessageTitle>
      <TranscriptionSubTitle>
        <Trans i18nKey="no_transcript.wrong_call_duration_description">
          Sorry, we can only transcribe calls that last a certain amount of
          time. Find more details in our
          <Anchor
            href={t("no_transcript.wrong_call_duration_help_link")}
            target="_blank"
          />
          article.
        </Trans>
      </TranscriptionSubTitle>
    </TranscriptionIllustrationLayout>
  );
}
